<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="navbar">
    <!-- <logo :collapse="false" /> -->
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <breadcrumb class="breadcrumb-container" />
    <div v-if="helpMessage.type === 'click'" class="help-message">
      <a
        :href="helpMessage.url"
        target="_blank"
      ><i class="el-icon-key" style="font-size:16px;left:5px" /></a>

    </div>
    <div v-else-if="helpMessage" class="help-message">
      <el-popover
        placement="right"
        width="400"
        trigger="click"
        popper-class="help-box-popover"
      >
        <div class="help-box">
          <span class="help-box-content">{{ helpMessage.message }}</span>
        </div>
        <span slot="reference" style="font-size:15px;">
          <svg-icon slot="reference" icon-class="help" />
        </span>
      </el-popover>
    </div>
    <Banner v-if="$global.isPC" />

    <div class="right">
      <SelectMenu v-if="$global.isPC" />
      <RightSDKWinTask v-show="$route.name === 'AdvertisingGameRelation' && $global.isPC" />
      <RightMenuTask v-if="$global.isPC" />
      <div v-if="$global.isPC" class="tickets-container">
        <el-popover
          v-model="visible"
          placement="left"
          width="400"
          trigger="click"
          popper-class="help-box-popover"
        >
          <div class="help-box">
            <span class="help-box-title">{{ updateMessage.title }}</span>
            <span class="help-box-content">{{ updateMessage.message }}</span>
          </div>
          <span slot="reference" class="icon-style">
            <i class="el-icon-tickets" />
          </span>
        </el-popover>
      </div>
      <notice class="navbar-notice-container" />
      <transition name="right">
        <div v-show="showUserInfo" class="right-menu">
          <el-dropdown class="user-container" trigger="click" size="medium">
            <div class="user-wrapper">
              <el-row type="flex">
                <el-row>
                  <el-avatar v-if="this.$store.getters.avatar" :size="40" :src="avatar" />
                  <div v-else class="avatar-box" :style="'background: ' + backgroundColorGroup">
                    <span>{{ name.substr(0,1) }}</span>
                  </div>
                </el-row>
                <el-row style="margin-left:8px">
                  <el-row class="user-name">{{ name }}</el-row>
                  <el-row class="user-title">
                    <template v-if="level===0">
                      神秘人
                    </template>
                    <template v-else-if="level===1">
                      {{ platform_name }}负责人
                    </template>
                    <template v-else-if="level===2">
                      {{ department_name }}负责人
                    </template>
                    <template v-else-if="level===3">
                      {{ department_group_name }}负责人
                    </template>
                    <template v-else-if="level===4">
                      {{ department_group_position_worker_name }}负责人
                    </template>
                    <template v-else-if="level===5">
                      {{ department_six_name }}负责人
                    </template>
                    <template v-else-if="level===6">
                      {{ department_seven_name }}负责人
                    </template>
                    <template v-else>
                      {{ department_seven_name }}-{{ department_eight_name }}
                    </template>
                  </el-row>
                </el-row>
              </el-row>
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <router-link to="/user/info">
                <el-dropdown-item>
                  个人中心
                </el-dropdown-item>
              </router-link>
              <el-dropdown-item divided @click.native="logout">
                <span style="display:block;text-align:center;">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
// import Logo from './Logo'
import Notice from './Notice'
import RightMenuTask from './RightMenuTask'
import RightSDKWinTask from './RightSDKWinTask'
import SelectMenu from './SelectMenu'
import Banner from './Banner'
import { HELPMESSAGE, UPDATAMESSAGE } from './const.js'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    // Logo,
    Notice,
    RightMenuTask,
    RightSDKWinTask,
    SelectMenu,
    Banner
  },
  data() {
    return {
      fullscreenLoading: false,
      helpMessage: '',
      updateMessage: UPDATAMESSAGE,
      backgroundColorGroup: 'rgb(64, 158, 255)',
      date: 'updata_06_10',
      updataState: '',
      visible: false,
      showUserInfo: true
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'platform_name',
      'department_name',
      'department_group_name',
      'department_group_position_name',
      'department_group_position_worker_name',
      'department_six_name',
      'department_seven_name',
      'department_eight_name',
      'level',
      'permission_module',
      'permission_routesType'
    ]),
    avatar() {
      return this.$store.getters.avatar
    }
  },
  watch: {
    $route() {
      this.getHelpMessage()
    },
    permission_routesType() {
      this.showUserInfo = false
      setTimeout(() => {
        this.showUserInfo = true
      }, 300)
    }
  },
  created() {
    this.getHelpMessage()
    this.updataState = localStorage.getItem(this.date)
  },
  mounted() {
    if (!this.updataState) {
      this.visible = true
      localStorage.setItem(this.date, true)
    }
  },
  methods: {
    getHelpMessage() {
      this.helpMessage = ''
      const list = HELPMESSAGE.filter(res => {
        return res.router === this.$route.path
      })
      this.helpMessage = list.length > 0 ? list[0] : ''
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      this.fullscreenLoading = true

      await this.$store.dispatch('websocket/close')

      await this.$store.dispatch('user/logout')
      // 删除缓存的标签
      await this.$store.dispatch('tagsView/delAllViews')

      this.fullscreenLoading = false

      this.$router.push(`/login`)
      location.reload(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: fixed;
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  z-index: 150;
  border-bottom: 1px solid #E4E4E4;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right {
    float: right;
    width: auto;

    .navbar-notice-container {
      display: inline-block;
      padding-top: 5px;
      // padding-right:10px;
      height: 48px;
    }
  }

  .right-menu {
    float: right;
    height: 100%;

    &:focus {
      outline: none;
    }
    &:hover {
      background-color: #F5F7FA;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .user-container {
      padding:0 20px;
      display: block;
      margin-top: 5px;
      .user-wrapper {
        position: relative;
        cursor: pointer;

      }
      .user-name {
        font-size: 16px;
        font-weight: 900;
        color: #9D9D9D;
      }
      .user-title {
        font-size: 12px;
        color: #9D9D9D;
      }
    }
  }

  .right-enter, .right-leave-to {
    transform: translate3d(100%, 0, 0);
  }
  .right-leave, .right-enter-to {
    transform: translate3d(0, 0, 0);
  }
  .right-enter-active, .right-leave-active {
    transition: all .2s;
  }

  .help-message{
    display: inline-block;
    height: 50px;
    line-height: 51px;
    margin-left: 10px;
    cursor: pointer;
    position: relative;
    top: -10px;
    i{
      color: #08af15;
      position: relative;
      top: 3px;
    }
  }
  .avatar-box{
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    font-size: 16px;
  }
  .tickets-container{
    float: left;
    line-height: 40px;
    width: 40px;
    text-align: center;
    height: 48px;
    cursor: pointer;
    i{
      position: relative;
      top: 6px;
    }
  }
  .tickets-container:hover{
    background: #F5F7FA;
  }
}
</style>
<style lang="scss">
@import "@/styles/mixin.scss";
.help-box-popover{
  padding: 0;
  background: rgba($color: #000, $alpha: 0.8);

  .help-box{
    padding: 12px;
    max-height: calc(100vh / 1.5);
    overflow: auto;
    color: #b5b2b2;
    @include scrollBar();
    .help-box-title{
      font-size: 14px;
      display: inline-block;
      text-align: center;
      width: 100%;
    }
    .help-box-content{
      padding: 0px 10px 0px 10px;
      display: inline-block;
      white-space: pre-wrap;
    }
  }
  .popper__arrow::after{
    border-right-color:rgba($color: #000, $alpha: 0.8)!important;
    border-left-color:rgba($color: #000, $alpha: 0.8)!important;
  }
}
.change-menu-navbar{
  position: relative;
  top: 5px;
  display: inline-block;
  height: 100%;
  width:100%;
}
.tickets-container-down .el-dropdown-menu__item {
  line-height: 24px;
  padding: 2px 15px;
  font-size: 12px;
}
.icon-style{
  font-size:15px;position:relative;display:inline-block;height:100%;width:100%;
}
@media  (max-height: 1000px) and (max-width: 1000px) {
  // 横屏时 时间控件留点位置可以触碰关闭
  .el-icon-tickets{
    font-size: 15px!important;
  }
}
@media  (max-width: 450px) {
  // 竖屏时 时间控件超出位置问题
  .el-icon-tickets{
    font-size: 15px!important;
  }
}
</style>
